import React from 'react';
import { Breadcrumb } from 'antd';
import { FolderOutlined, HomeOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import './FolderBreadcrumb.scss';

export default function FolderBreadcrumb({
  currentFolder,
  folders = [],
  onNavigate,
  showRoot = true
}) {
  const buildBreadcrumbItems = () => {
    const items = [];
    
    if (showRoot) {
      items.push({
        title: (
          <span onClick={() => onNavigate(null)} className="breadcrumb-clickable">
            <HomeOutlined /> All Screens
          </span>
        )
      });
    }
    
    if (currentFolder) {
      const folder = folders.find(f => f._id === currentFolder);
      if (folder) {
        // Add ancestor folders
        if (folder.ancestors && folder.ancestors.length > 0) {
          folder.ancestors.forEach((ancestorId, index) => {
            // Handle ancestorId as object or string
            const actualAncestorId = ancestorId?._id || ancestorId;
            const ancestor = folders.find(f => f._id === actualAncestorId);
            if (ancestor) {
              items.push({
                title: (
                  <span 
                    onClick={() => onNavigate(actualAncestorId)} 
                    className="breadcrumb-clickable"
                  >
                    <FolderOutlined /> {ancestor.name}
                  </span>
                )
              });
            } else {
              // Fallback to ancestorNames if ancestor folder not found
              const ancestorName = folder.ancestorNames && folder.ancestorNames[index] 
                ? folder.ancestorNames[index] 
                : `Ancestor ${index + 1}`;
              items.push({
                title: (
                  <span className="breadcrumb-disabled">
                    <FolderOutlined /> {ancestorName}
                  </span>
                )
              });
            }
          });
        }
        
        // Add current folder
        items.push({
          title: (
            <span className="breadcrumb-current">
              <FolderOutlined /> {folder.name}
            </span>
          )
        });
      }
    }
    
    return items;
  };

  return (
    <div className="folder-breadcrumb">
      <Breadcrumb items={buildBreadcrumbItems()} />
    </div>
  );
}

FolderBreadcrumb.propTypes = {
  currentFolder: PropTypes.string,
  folders: PropTypes.array,
  onNavigate: PropTypes.func.isRequired,
  showRoot: PropTypes.bool
};